/* Carska - baner zgody na cookies: interfejs, zapis wyboru i egzekucja zgody.
   ZAKRES: UI, zapis decyzji uzytkownika oraz przekazanie jej do GA4, Meta Pixela
   i Shopify Customer Privacy API. Stan domyslny (denied) ustawia blok Consent Mode v2
   w layout/theme.liquid, ktory czyta ten sam zapis PRZED zaladowaniem gtag i fbq.

   HAK (jedno miejsce podpiecia dla kolejnych konsumentow):
     - zdarzenie na document: 'carska:consent', e.detail = { v:2, necessary:true, analytics:bool, ts:ISO }
       Odpala sie przy kazdym zapisie wyboru ORAZ raz przy ladowaniu strony, jesli wybor jest juz zapisany.
     - window.CarskaConsent.get()        -> zapisany wybor albo null
     - window.CarskaConsent.onChange(fn) -> fn(consent) przy kazdej zmianie
     - window.CarskaConsent.open()       -> otwiera baner ponownie (to samo, co link w stopce)

   ZAPIS: localStorage['ck_cookie_consent'] (glowny) + cookie 'ck_cookie_consent' (lustro, 365 dni).
   Wybor wygasa po 365 dniach, wtedy baner wraca. Zmiana VERSION tez przywraca baner.

   SHOPIFY CUSTOMER PRIVACY API (SYNC_SHOPIFY): po zapisie wyboru (i raz przy ladowaniu, gdy wybor
   juz jest) decyzja trafia do Shopify.customerPrivacy.setTrackingConsent(). To kanal, ktorym Shopify
   gatuje WLASNE piksele (Customer Events) i Shopify Analytics dla odwiedzajacych z UE. Bez tego, po
   wylaczeniu natywnego banera Shopify w adminie, te piksele bylyby zablokowane na zawsze.
   Mapowanie od v2: jedna zgoda 'analytics' steruje wszystkimi czterema polami Shopify
   (analytics, marketing, preferences, sale_of_data).

   CONSENT MODE V2 (SYNC_TAGS): po zapisie wyboru (i raz przy ladowaniu, gdy wybor juz jest)
   decyzja idzie do gtag('consent','update'). Gatowane jest GA4 G-Z1XYXZ2P7K.
   Mapowanie: analytics -> analytics_storage (Google) oraz analytics + marketing (Shopify
   Customer Privacy). Sygnaly reklamowe Google (ad_storage, ad_user_data, ad_personalization,
   personalization_storage) sa TRWALE denied - na tym sklepie nie ma tagu Google Ads, wiec nic
   to nie kosztuje.

   META PIXEL 1554901085574551 JEST CELOWO POZA BRAMKA (decyzja Jakuba, 2026-09-03).
   Odpala sie niezaleznie od wyboru w banerze. Dlatego baner NIE pyta juz o kategorie
   "Marketingowe": nie zapisujemy odmowy, ktorej i tak nie respektujemy. Przywrocenie bramki
   to dodanie kategorii z powrotem w snippets/carska-cookie-banner.liquid, przywrocenie pola
   marketing w save() i fbq('consent', ...) w layout/theme.liquid oraz w syncTags().

   Uwaga przy diagnozie: pod denied GA4 nadal wysyla bezcookiowe pingi do google-analytics.com.
   To jest zamierzone (modelowanie konwersji). Dowodem zgody na GA jest cookie _ga, nie ruch sieciowy. */
(function () {
  var KEY = 'ck_cookie_consent';
  var VERSION = 2;  // v2 (2026-09-03): usunieta kategoria marketingowa. Bump uniewaznia stare
                    // zapisy z pola marketing, zeby w przegladarkach nie zostawaly odmowy, ktorych
                    // nie respektujemy. Skutek uboczny: baner pokazuje sie ponownie wszystkim.
  var MAX_AGE_DAYS = 365;
  var SYNC_SHOPIFY = true; // false = tylko localStorage/cookie/zdarzenie, bez Customer Privacy API
  var SYNC_TAGS = true;    // false = rozbraja Consent Mode dla gtag (awaryjny wylacznik)
  var root = document.querySelector('[data-ck-consent]');
  if (!root) return;

  var card = root.querySelector('.ck-consent-card');
  var views = root.querySelectorAll('[data-ck-view]');
  var inputs = { analytics: root.querySelector('[data-ck-consent-cat="analytics"] input') };
  var listeners = [];
  var mode = 'first';
  var lastFocus = null;

  function safeParse(s) { try { return JSON.parse(s); } catch (e) { return null; } }
  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + KEY + '=([^;]*)'));
    return m ? safeParse(decodeURIComponent(m[1])) : null;
  }
  function valid(c) {
    if (!c || c.v !== VERSION || !c.ts) return false;
    var age = (Date.now() - Date.parse(c.ts)) / 864e5;
    return isFinite(age) && age >= 0 && age < MAX_AGE_DAYS;
  }
  function read() {
    var c = null;
    try { c = safeParse(localStorage.getItem(KEY)); } catch (e) {}
    if (!valid(c)) c = readCookie();
    return valid(c) ? c : null;
  }
  function write(c) {
    var s = JSON.stringify(c);
    try { localStorage.setItem(KEY, s); } catch (e) {}
    document.cookie = KEY + '=' + encodeURIComponent(s) + '; Max-Age=' + (MAX_AGE_DAYS * 86400) + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function syncShopify(c) {
    if (!SYNC_SHOPIFY || !window.Shopify) return;
    var apply = function () {
      var cp = window.Shopify.customerPrivacy;
      if (!cp || typeof cp.setTrackingConsent !== 'function') return;
      try {
        if (typeof cp.currentVisitorConsent === 'function') {
          var cur = cp.currentVisitorConsent() || {};
          var same = cur.analytics === (c.analytics ? 'yes' : 'no') && cur.marketing === (c.analytics ? 'yes' : 'no');
          if (same) return; /* juz zgodne, bez kolejnego zapisu przy kazdym wejsciu */
        }
        /* Jedna zgoda steruje obiema kategoriami Shopify. Bez tego piksele Customer Events
           i Shopify Analytics zostalyby zablokowane na stale dla odwiedzajacych z UE. */
        cp.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.analytics, preferences: !!c.analytics, sale_of_data: !!c.analytics }, function () {});
      } catch (e) {}
    };
    if (window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') { apply(); return; }
    if (typeof window.Shopify.loadFeatures === 'function') {
      try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) apply(); }); } catch (e) {}
    }
  }
  function syncTags(c) {
    if (!SYNC_TAGS) return;
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('consent', 'update', {
          analytics_storage: c.analytics ? 'granted' : 'denied',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          personalization_storage: 'denied'
        });
      } catch (e) {}
    }
    /* Meta celowo bez fbq('consent', ...) - patrz naglowek pliku. */
  }
  function emit(c) {
    for (var i = 0; i < listeners.length; i++) { try { listeners[i](c); } catch (e) {} }
    try { document.dispatchEvent(new CustomEvent('carska:consent', { detail: c })); } catch (e) {}
    syncTags(c);
    syncShopify(c);
  }
  function save(analytics) {
    var c = { v: VERSION, necessary: true, analytics: !!analytics, ts: new Date().toISOString() };
    write(c);
    emit(c);
    close();
  }

  function showView(name) {
    for (var i = 0; i < views.length; i++) views[i].hidden = views[i].getAttribute('data-ck-view') !== name;
    var target = root.querySelector('[data-ck-view="' + name + '"] [data-ck-consent-primary]') || root.querySelector('[data-ck-view="' + name + '"] .btn');
    if (target) target.focus({ preventScroll: true });
  }
  function fillSwitches() {
    var c = read();
    if (inputs.analytics) inputs.analytics.checked = !!(c && c.analytics);
  }
  function open(m) {
    mode = m === 'reopen' ? 'reopen' : 'first';
    lastFocus = document.activeElement;
    root.classList.toggle('is-reopen', mode === 'reopen');
    fillSwitches();
    root.hidden = false;
    document.documentElement.classList.add('ck-consent-open');
    document.body.classList.add('ck-consent-open');
    showView('main');
    if (card) card.scrollTop = 0;
  }
  function close() {
    root.hidden = true;
    document.documentElement.classList.remove('ck-consent-open');
    document.body.classList.remove('ck-consent-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* Klawiatura: Tab krazy wewnatrz karty; Escape zamyka tylko przy ponownym otwarciu ze stopki. */
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mode === 'reopen') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(root.querySelectorAll('button, a[href], input'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ck-consent-action]') : null;
    if (t) {
      var a = t.getAttribute('data-ck-consent-action');
      if (a === 'accept-all') save(true);
      else if (a === 'necessary') save(false);
      else if (a === 'customize') showView('prefs');
      else if (a === 'back') showView('main');
      else if (a === 'save') save(inputs.analytics && inputs.analytics.checked);
      else if (a === 'close') close();
      return;
    }
    if (mode === 'reopen' && e.target.hasAttribute('data-ck-consent-overlay')) close();
  });

  /* Link "Ustawienia plikow cookies" w stopce (i kazdy inny element z data-ck-consent-open). */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ck-consent-open]') : null;
    if (!t) return;
    e.preventDefault();
    open('reopen');
  });

  window.CarskaConsent = {
    KEY: KEY,
    get: read,
    open: function () { open('reopen'); },
    onChange: function (fn) { if (typeof fn === 'function') listeners.push(fn); }
  };

  var stored = read();
  if (stored) emit(stored); else open('first');
})();
